// eslint-disable-next-line
import React, { lazy as baseLazy, Suspense } from 'react';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { State } from 'history';

import Login from '@nal/components/Auth/Login/Login';
import { RoutingAction } from 'app/redux/routing/actions';
import AuthGuard from './guards/Auth.guard';
import Layout from '../@nal/components/Layout/Layout';
import Layout2 from '@nal/components/Layout2/Layout2';
import _ from 'lodash';

type CustomRoute = { path: string; component: string };

let UseLayout: React.FC<any>;
const SELECTED_LAYOUT = _.parseInt(process.env.REACT_APP_LAYOUT || '1', 10);

switch (SELECTED_LAYOUT) {
    case 2:
        UseLayout = Layout2;
        break;
    default:
        UseLayout = Layout;
}

const AuthRouteCustom: CustomRoute[] = [];

const PublicRoutes: React.FC<{ authRouteCustom?: CustomRoute[] }> = ({ authRouteCustom }) => {
    const dispatch = useDispatch();

    const lazy = (loadModule: Promise<any>) => {
        return baseLazy(() =>
            Promise.resolve(
                dispatch({
                    type: RoutingAction.SHOW_REQUEST,
                })
            )
                .then(() => loadModule)
                .finally(() => {
                    dispatch({
                        type: RoutingAction.HIDDEN_REQUEST,
                    });
                })
        );
    };

    return (
        <BrowserRouter>
            <Suspense fallback={null}>
                <Switch>
                    <Route path="/auth/login" exact component={Login} />
                    <UseLayout>
                        <Switch>
                            <Route path="/none-require-login" exact component={() => <>None required login</>} />
                            <AuthGuard>
                                <Switch>
                                    {authRouteCustom?.length &&
                                        authRouteCustom.map(({ path, component }, index) => {
                                            return (
                                                <Route
                                                    key={index}
                                                    path={path}
                                                    component={lazy(import(`${component}`))}
                                                />
                                            );
                                        })}
                                    <Route
                                        key={-2}
                                        path="/"
                                        exact
                                        component={lazy(import('app/components/HomePage/HomePage'))}
                                    />

                                    <Route key={-3} component={() => <Redirect to="/404" />} />
                                </Switch>
                            </AuthGuard>
                        </Switch>
                    </UseLayout>
                </Switch>
            </Suspense>
        </BrowserRouter>
    );
};

function mapStateToProps(state: State) {
    return {
        authRouteCustom: AuthRouteCustom,
    };
}
export default connect(mapStateToProps)(PublicRoutes);

AuthRouteCustom.push({
    path: '/users',
    component: './components/Users/Users',
});

AuthRouteCustom.push({
    path: '/projects/:id',
    component: './components/Project/ProjectSetting/ProjectSetting',
});

AuthRouteCustom.push({
    path: '/projects',
    component: './components/Project/Project',
});

AuthRouteCustom.push({
    path: '/admin-accounts',
    component: './components/AdminUser/AdminUser',
});

AuthRouteCustom.push({
    path: '/user-accounts',
    component: './components/UserAccount/UserAccount',
});
